import styled from 'styled-components';
import { Input as ShrikeInput } from '@arcadiapower/shrike';

export const Input = styled(ShrikeInput).attrs({
  margin: { bottom: '32px' },
})``;
